import React from 'react';
import PropTypes from 'prop-types';
import './StepIndicator.css';

const StepIndicator = ({ currentStep, completedSteps }) => (
  <div className="step-indicator">
    {[1, 2, 3].map((step) => (
      <span key={step} className={`step ${step === currentStep ? 'active' : ''} ${completedSteps >= step ? 'completed' : ''}`}>
        {completedSteps >= step ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className="check-icon">
            <path fillRule="evenodd" d="M16.704 4.153a.75.75 0 01.143 1.052l-8 10.5a.75.75 0 01-1.127.075l-4.5-4.5a.75.75 0 011.06-1.06l3.894 3.893 7.48-9.817a.75.75 0 011.05-.143z" clipRule="evenodd" />
          </svg>
        ) : step}
      </span>
    ))}
  </div>
);

StepIndicator.propTypes = {
  currentStep: PropTypes.number.isRequired,
  completedSteps: PropTypes.number.isRequired,
};

export default StepIndicator; 